import React from "react";
import "./css/userChats.css";

function UserChats({ userSearch }) {
  return (
    <div className="chat-item user-chat-item">
      <div className="avatar-wrapper">
        <img className="avatar" src="./Assets/user.png" alt="You" />
      </div>
      <div className="message-content">
        <div className="author-name">You</div>
        <div className="user-bubble">
          <p>{userSearch}</p>
        </div>
      </div>
    </div>
  );
}

export default UserChats;
